import {
  FETCH_DS1_ALL_PRODUCTS,
  RESET_DS1_ALL_PRODUCTS,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const ds1AllProductsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DS1_ALL_PRODUCTS:
      return { list: action.payload, others: action.others };
    case RESET_DS1_ALL_PRODUCTS:
      return initialState;
    default:
      return state;
  }
};

export default ds1AllProductsReducer;
